import { defineMessages } from 'react-intl';

/** The frame of the directed video wizard (design directed-video DvTop, DvSide, j). */
export const directedMessages = defineMessages({
  // The top bar (DvTop)
  back: { id: 'app.sml.musicVideo.directed.top.back', defaultMessage: 'Song' },
  songLine: {
    id: 'app.sml.musicVideo.directed.top.songLine',
    defaultMessage: '{artist} · {length} · directed video',
  },
  songLineNoLength: {
    id: 'app.sml.musicVideo.directed.top.songLineNoLength',
    defaultMessage: '{artist} · directed video',
  },
  beta: { id: 'app.sml.musicVideo.directed.beta', defaultMessage: 'Beta' },
  saved: { id: 'app.sml.musicVideo.directed.top.saved', defaultMessage: 'Saved' },
  saving: { id: 'app.sml.musicVideo.directed.top.saving', defaultMessage: 'Saving' },
  credits: { id: 'app.sml.musicVideo.directed.top.credits', defaultMessage: 'Credits <b>{count}</b>' },
  creditsNoLimit: { id: 'app.sml.musicVideo.directed.top.creditsNoLimit', defaultMessage: 'Credits <b>no limit</b>' },
  stepsLabel: { id: 'app.sml.musicVideo.directed.top.steps', defaultMessage: 'The steps of the directed video' },
  stepCast: { id: 'app.sml.musicVideo.directed.step.cast', defaultMessage: 'Cast' },
  stepStory: { id: 'app.sml.musicVideo.directed.step.story', defaultMessage: 'Story' },
  stepStyle: { id: 'app.sml.musicVideo.directed.step.style', defaultMessage: 'Style' },
  stepScript: { id: 'app.sml.musicVideo.directed.step.script', defaultMessage: 'Script' },
  stepPrice: { id: 'app.sml.musicVideo.directed.step.price', defaultMessage: 'Price' },
  stepMake: { id: 'app.sml.musicVideo.directed.step.make', defaultMessage: 'Make' },
  stepOpen: { id: 'app.sml.musicVideo.directed.step.open', defaultMessage: 'Open the step {step} again' },
  // The phone top bar (j)
  phoneTitle: { id: 'app.sml.musicVideo.directed.phone.title', defaultMessage: 'Directed video' },
  phoneStep: {
    id: 'app.sml.musicVideo.directed.phone.step',
    defaultMessage: '{title} · step {number} of {count} · {step}',
  },

  // The states of the frame
  opening: { id: 'app.sml.musicVideo.directed.opening', defaultMessage: 'Opening the directed video' },
  openFailed: {
    id: 'app.sml.musicVideo.directed.openFailed',
    defaultMessage: 'The directed video did not open. Try again.',
  },
  cancelledTitle: {
    id: 'app.sml.musicVideo.directed.cancelled.title',
    defaultMessage: 'This directed video was cancelled',
  },
  cancelledText: {
    id: 'app.sml.musicVideo.directed.cancelled.text',
    defaultMessage: 'Start a new one from the song page. The old one stays for the record.',
  },
  backToSong: { id: 'app.sml.musicVideo.directed.backToSong', defaultMessage: 'Back to the song' },

  // The side panel (b1, DvSide)
  sideTitle: { id: 'app.sml.musicVideo.directed.side.title', defaultMessage: 'What the director reads' },
  factSong: { id: 'app.sml.musicVideo.directed.side.song', defaultMessage: 'Song' },
  factSongValue: { id: 'app.sml.musicVideo.directed.side.songValue', defaultMessage: '{title} · {artist}' },
  factLength: { id: 'app.sml.musicVideo.directed.side.length', defaultMessage: 'Length' },
  factLengthBpm: { id: 'app.sml.musicVideo.directed.side.lengthBpm', defaultMessage: '{length} · {bpm} BPM' },
  factLyrics: { id: 'app.sml.musicVideo.directed.side.lyrics', defaultMessage: 'Lyrics' },
  lyricsSynced: {
    id: 'app.sml.musicVideo.directed.side.lyricsSynced',
    defaultMessage: 'Synced, {count, plural, one {# line} other {# lines}}',
  },
  lyricsSyncing: { id: 'app.sml.musicVideo.directed.side.lyricsSyncing', defaultMessage: 'Syncing' },
  lyricsNone: { id: 'app.sml.musicVideo.directed.side.lyricsNone', defaultMessage: 'No synced lyrics' },
  sections: { id: 'app.sml.musicVideo.directed.side.sections', defaultMessage: 'Sections' },
  rolesTitle: { id: 'app.sml.musicVideo.directed.side.rolesTitle', defaultMessage: 'Roles' },
  rolesText: {
    id: 'app.sml.musicVideo.directed.side.rolesText',
    defaultMessage:
      '<b>Person</b>: you, a band member, an actor. <b>Place</b>: a room, a street, a forest. <b>Object</b>: a car, a guitar, a jacket. <b>Style</b>: a photo whose look you want.',
  },
  usedTitle: { id: 'app.sml.musicVideo.directed.side.usedTitle', defaultMessage: 'How it is used' },
  usedText: {
    id: 'app.sml.musicVideo.directed.side.usedText',
    defaultMessage:
      'Each new shot can use up to {count} of these photos. The director picks the {count} that matter for that shot.',
  },
  sideHint: {
    id: 'app.sml.musicVideo.directed.side.hint',
    defaultMessage: 'The steps up to the price cost nothing. You can leave and come back: every step is saved.',
  },
});
